import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { RouterReducerState } from '@ngrx/router-store';
import { select, Store } from '@ngrx/store';
import { selectNavigationId, selectUrl } from './router-state.selectors';

@Injectable()
export class RouterStateFacade {
  protected store = inject<
    Store<{
      router: RouterReducerState;
    }>
  >(Store);

  getNavigationId(): Observable<number> {
    return this.store.pipe(select(selectNavigationId));
  }

  getUrl(): Observable<string> {
    return this.store.pipe(select(selectUrl));
  }
}
